<template>
  <a-modal
      v-model="visible"
      title="消息详情"
      :width="600"
      :footer="null" 
      :bodyStyle="{ padding: '24px' }"
      @cancel="handleClose"
    >
      <!-- 使用描述列表展示关键信息 -->
      <a-descriptions bordered :column="1">
        <!-- 消息标题 -->
        <a-descriptions-item label="消息标题">
          <span style="font-weight: 500; font-size: 16px;">
            {{ currentMessage.title }}
          </span>
        </a-descriptions-item>

        <!-- 消息类型 (使用 Tag 增强视觉) -->
        <a-descriptions-item label="消息类型">
          <a-tag :color="getTypeColor(currentMessage.type)">
            {{ currentMessage.type }}
          </a-tag>
        </a-descriptions-item>

        <!-- 项目名称 -->
        <a-descriptions-item label="所属项目">
          {{ currentMessage.projectName }}
        </a-descriptions-item>
      </a-descriptions>

      <!-- 消息内容区域 -->
      <div class="message-content-wrapper">
        <div class="content-label">消息内容：</div>
        <div class="content-text">
          {{ currentMessage.content }}
        </div>
      </div>
    </a-modal>
</template>

<script>
  import { getAction,postAction } from '@/api/manage'

  export default {
    name: "MesModal",
    props: {
      id: {
        type: String,
        default: ''
      },
    },
    components: { },
    data () {
      return {
        title:"操作",
        visible: false,
        currentMessage: {},        
        confirmLoading: false,        
        url: {
          read: "/project/projectNotice/readById",
          queryById: "/project/projectNotice/queryById",
        },
      }
    },
    created () {
    },
    mounted() {
      // this.getMes();
    },
    methods: {      
      handleClose () {        
        this.visible = false;
      },
      read(id) {
        var that = this;
        postAction(this.url.read,{id:id}).then((res)=>{
              if(res.success){                
                that.$emit('loadData');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
            })
      },
      handleCancel () {
        this.close()
      },
      view(obj){
        this.visible = true;
        getAction(this.url.queryById, { id: obj.id }).then(res => {
          if (res.success) {
            this.currentMessage = res.result
            if(this.currentMessage.read != 1){
              this.read(obj.id);
            }            
          }else{
            this.$message.warning(res.message)
          }
        })        
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      getTypeColor(type) {
        const map = {
          '通知': 'blue',
          '警告': 'orange',
          '错误': 'red',
          '成功': 'green',
          '考核': 'purple'
        };
        return map[type] || 'default';
      },
    }
  }
</script>

<style lang="less" scoped>
  .message-content-wrapper {
    margin-top: 24px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background-color: #fafafa;
    padding: 16px;
  }

  .content-label {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 8px;
    font-size: 14px;
  }

  .content-text {
    white-space: pre-wrap; /* 保留换行符，自动换行 */
    word-break: break-all;
    color: rgba(0, 0, 0, 0.65);
    line-height: 1.6;
    font-size: 14px;
    
    /* 如果内容特别长，可以限制最大高度并滚动 */
    max-height: 300px;
    overflow-y: auto;
  }

  /* 针对 a-descriptions 的细微调整 */
  ::v-deep .ant-descriptions-item-label {
    font-weight: 500;
    width: 120px;
  }
</style>